import styled from 'styled-components';

import { FormRow } from '@components/Grid';

export const HeaderRow = styled(FormRow)`
  color: ${(props) => props.theme.colors.black};
  font-size: 15px;
  font-weight: 600;
`;
